import React from 'react';
import _ from 'lodash';
import HeaderThin from 'app/components/layout/HeaderThin';
import { Link } from 'react-router-dom';
import history from 'app/routes/history';
import Isvg from 'react-inlinesvg';

import PayoutSummaryIcon from './summary.svg';
import PayoutDetailedIcon from './detailed.svg';
import MatchPaymentsGridIcon from './grid.svg';
import TeamConnectionsIcon from './connection.svg';
import OverdueMatchPaymentsIcon from './dollar.svg';

interface IReportsListProps {

}

export default class ReportsList extends React.Component<IReportsListProps> {
  static defaultProps: IReportsListProps = {

  };

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              divider
              title="Reports"
              infoText="Reports are updated every 15 minutes."
            />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <h3>Financial Reports</h3>
          </div>
        </div>
        {/* <div className="row">
          <div className="col">
            <div className="divider full" />
          </div>
        </div> */}
        <div className="row with-margin-top">
          <div className="col">
            <div className="card report-card d-inline-block margin-right-20 margin-bottom-20" onClick={() => history.push('/reports/payout-summary')}>
              <div className="with-margin-top d-inline-block">
                <Isvg className="report-icon" src={PayoutSummaryIcon} />
                <h4 className="text-black">Payout Summary</h4>
              </div>
              <p>Payouts made to your bank account with a summary of gross amount, net amount and fees. Useful to reconcile Teammo payouts against your bank statements.</p>
            </div>
            <div className="card report-card d-inline-block margin-right-20 margin-bottom-20" onClick={() => history.push('/reports/payout-detailed')}>
              <div className="with-margin-top d-inline-block">
                <Isvg className="report-icon" src={PayoutDetailedIcon} />
                <h4 className="text-black">Payout Detailed</h4>
              </div>
              <p>Detailed breakdown of payments and refunds that make up each payout. Useful to reference for detailed payout analysis.</p>
            </div>
            <div className="card report-card d-inline-block margin-right-20 margin-bottom-20" onClick={() => history.push('/reports/refund-detailed')}>
              <div className="with-margin-top d-inline-block">
                <Isvg className="report-icon" src={PayoutDetailedIcon} />
                <h4 className="text-black">Refund Detailed</h4>
              </div>
              <p>Detailed breakdown of refunds. Useful to reference against bank debits.</p>
            </div>
            <div className="card report-card d-inline-block margin-right-20 margin-bottom-20" onClick={() => history.push('/reports/bank-debit-detailed')}>
              <div className="with-margin-top d-inline-block">
                <Isvg className="report-icon" src={PayoutDetailedIcon} />
                <h4 className="text-black">Bank Debit Detailed</h4>
              </div>
              <p>Detailed list of bank debits, which are charged to your bank account to cover refunds. Useful to reference against refunds.</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="divider full" />
          </div>
        </div>
        <div className="row with-margin-top-10">
          <div className="col">
            <h3>Payment Reports</h3>
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col">
            <div className="card report-card d-inline-block margin-right-20 margin-bottom-20" onClick={() => history.push('/reports/match-payments-grid')}>
              <div className="with-margin-top d-inline-block">
                <Isvg className="report-icon" src={MatchPaymentsGridIcon} />
                <h4 className="text-black">Match Payments Grid</h4>
              </div>
              <p>Grid view of match payments for the current active competitions. Ordered by competition, team and rounds.</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="divider full" />
          </div>
        </div>
        <div className="row with-margin-top-10">
          <div className="col">
            <h3>Operational Reports</h3>
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col">
            <div className="card report-card d-inline-block margin-right-20 margin-bottom-20" onClick={() => history.push('/reports/team-connections')}>
              <div className="with-margin-top d-inline-block">
                <Isvg className="report-icon" src={TeamConnectionsIcon} />
                <h4 className="text-black">Team Connections</h4>
              </div>
              <p>List of teams and which team contacts have connected their Teammo account to the team.</p>
            </div>
            <div className="card report-card d-inline-block margin-right-20 margin-bottom-20" onClick={() => history.push('/reports/overdue-match-payments')}>
              <div className="with-margin-top d-inline-block">
                <Isvg className="report-icon" src={OverdueMatchPaymentsIcon} />
                <h4 className="text-black">Overdue Match Payments</h4>
              </div>
              <p>List of all overdue match payments for the current season.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
